<template>
  <div>
    <div v-if="loading">
      <img
        class="logo"
        src="@/assets/lundbeck/lundbeck-logo-1280x1280.png"
        alt="Lundbeck Logo"
      />
      <img class="spinner" src="/image/spinner.gif" />
    </div>
    <div v-if="!loading && error" class="bind-success">
      <div class="banner">
        <img src="@/assets/lundbeck/error.png" alt="success" />
        <div class="success-title">出错啦</div>
      </div>

      <img
        class="logo"
        src="@/assets/lundbeck/lundbeck-logo-1280x1280.png"
        alt="Lundbeck Logo"
      />
      <div class="success-text">
        {{ msg }}
      </div>
    </div>
    <div v-if="showContent">
      <div v-if="htmlContent" ref="htmlContent" class="html-content">
        <template v-for="block in htmlContentBlocks">
          <div
            v-if="block.type === 'html'"
            :key="block.key"
            v-html="block.html"
          ></div>
          <public-questionnaire
            v-else-if="canRenderSurveyBlock(block)"
            :key="block.key"
            class="embedded-survey"
            :content-id="block.contentId"
            :questionnaire-id="block.questionnaireId"
            :open-id="open_id"
            :physician="openPhysician"
            :show-title="false"
            :show-submit-button="!isContentPreview"
          />
        </template>
      </div>
      <pdf v-else-if="fileLocalLink" :src="fileLocalLink" />
      <public-questionnaire
        v-else-if="showStandaloneSurvey"
        class="embedded-survey"
        :content-id="content.content_id"
        :questionnaire-id="content.questionnaire_id"
        :open-id="open_id"
        :physician="openPhysician"
        :show-title="false"
        :show-submit-button="!isContentPreview"
      />
      <iframe
        v-else
        :src="fileLocalLink"
        style="width: 100vw; height: 100vh; border: none"
        scrolling="yes"
      ></iframe>
    </div>
    <div v-if="showAuthPopup" class="auth-popup" :catchtouchmove="true">
      <div class="popup-mask" :catchtouchmove="true" @click="closeAuthPopup"></div>
      <div class="popup-content bottom" :catchtouchmove="true">
        <div class="popup-title">点击继续认证，查看完整内容</div>
        <div class="popup-desc">您访问的内容需要进行医疗卫生专业人士认证才能继续</div>
        <div class="popup-buttons">
          <!-- <div class="popup-btn cancel-btn">关闭窗口</div> -->
          <button class="popup-btn confirm-btn" @click="authorize">继续认证</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getLocalStorage, setLocalStorage} from '@/utils/index';
import {getWeChatConfig, getWeChatInfoByCode} from '@/api/wechat';
import {
  getLogContentSend,
  getPhysicianWechatDetail,
  getContent,
  getContentById,
  logContentOpen,
  logContentOpenDuration,
  logContentForward,
} from '@/api/content';
import pdf from 'vue-pdf';
import {getPhysicianWechatDetailByOpenId} from '../../api/content';
import {weixinOASDK} from '@/utils/weixinOA';
import * as py from '@/api/Physicians';
import {getMimeTypeBySuffix} from '@/utils/index';
import PublicQuestionnaire from './components/PublicQuestionnaire.vue';

export default {
  components: {
    pdf,
    PublicQuestionnaire,
    // swipeDialog,
  },
  data() {
    return {
      open_id: '',
      send_id: '',
      content_id: '',
      loading: true,
      msg: '对不起，验证失败',
      error: false,
      contentSend: null,
      content: null,
      showContent: false,
      toPhysician: null, // physician_weixin from log content send
      openPhysician: null,
      isPdf: false,
      logOpenId: '',
      ticks: 0,
      intervalId: null,
      s3Key: '',
      fileLocalLink: '',
      htmlContent: null,
      showAuthPopup: false,
      canAnswerSurvey: false,
      isContentPreview: false,
      htmlInteractionRoot: null,
      htmlContentClickHandler: null,
      htmlSwipeTouchStartHandler: null,
      htmlSwipeTouchMoveHandler: null,
      htmlSwipeTouchEndHandler: null,
      htmlSwipeTouchCancelHandler: null,
      htmlSwipeTouch: null,
      htmlSwipeSuppressClickUntil: 0,
    };
  },
  computed: {
    contentQuestionnaireId() {
      return this.content && this.content.questionnaire_id
        ? String(this.content.questionnaire_id)
        : '';
    },
    htmlContentBlocks() {
      return this.buildHtmlContentBlocks(this.htmlContent || '');
    },
    showStandaloneSurvey() {
      return this.canAnswerSurvey &&
        this.showContent &&
        this.content &&
        this.content.questionnaire_id &&
        !this.htmlContent &&
        !this.fileLocalLink &&
        !this.showAuthPopup;
    },
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.teardownHtmlInteractions();
  },
  unmounted() {
    // Vue 3 中使用 unmounted
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.teardownHtmlInteractions();
  },
  methods: {
    init() {
      this.open_id = getLocalStorage('open_id');
      const token = getLocalStorage('token');
      const urlParams = new URLSearchParams(window.location.search);
      this.send_id = urlParams.get('send_id');
      this.content_id = urlParams.get('content_id') || urlParams.get('cid') || '';

      if (!this.send_id && this.content_id) {
        this.loadContentPreviewById(this.content_id);
        return;
      }

      if (this.open_id && token) {
        // 打开文章
        getPhysicianWechatDetailByOpenId(this.open_id).then((res) => {
          if (res && res.data && res.data.physician_id) {
            // 存在医生
            this.openPhysician = res.data;
          } else {
            this.openPhysician = {
              physician_id: null,
              open_id: this.open_id,
              union_id: null,
            };
          }
          if (this.send_id) {
            // load
            getLogContentSend(this.send_id)
              .then((res) => {
                this.contentSend = res.data;
                if (this.contentSend && this.contentSend.receiver_physician_id) {
                  getPhysicianWechatDetail(this.contentSend.receiver_physician_id)
                    .then((res) => {
                      if (res && res.data && res.data.physician_id) {
                        // 医生已绑定，判断open_id是否一致
                        this.toPhysician = res.data;
                        // this.loading = false;
                        console.log(
                          this.toPhysician.open_id,
                          this.open_id,
                          this.toPhysician,
                        );
                        // 医生是否有绑定过（openid为空）
                        if (this.toPhysician.open_id) {
                          if (this.toPhysician.open_id === this.open_id) {
                            this.openPhysician = this.toPhysician;
                            // open_id一致的话，判断是否签署了知情同意
                            if (this.toPhysician.is_consent) {
                              // Success
                              this.loadContent();
                            } else {
                              // this.authorize();
                              this.previewContent();
                            }
                          } else {
                            // this.loadContent();
                            if (this.contentSend.content_type === '直播' && this.contentSend.conference_id) {
                              // if (this.contentSend.content_type === '直播' && this.contentSend.content_url) {
                              // 用户不一致，但也继续打开
                              window.location.href = `/public/live?cid=${this.contentSend.content_id}`; // this.contentSend.content_url;
                            } else if (this.contentSend.content_type === '问卷' && this.contentSend.questionnaire_id) {
                              // 用户不一致，但也继续打开
                              window.location.href = `/public/survey?cid=${this.contentSend.content_id}`;
                            } else {
                              this.loading = false;
                              this.error = true;
                              this.msg = '对不起，本页面仅限指定用户打开';
                            }
                          }
                        } else {
                          if (
                            this.openPhysician &&
                            this.openPhysician.physician_id
                          ) {
                            // 已注册的医生，直接打开
                            this.loadContent();
                          } else {
                            // 从未注册的医生，绑定到当前客户
                            // 医生未绑定，openid为空
                            if (!this.toPhysician.is_consent) {
                              // 医生未绑定，继续绑定流程
                              // this.authorize();
                              this.previewContent();
                            } else {
                              // 已签署过知情同意，直接绑定
                              // this.authorize();
                              this.previewContent();
                            }
                          }
                        }
                      } else {
                        // 医生未绑定，继续绑定流程
                        // this.authorize();
                        this.previewContent();
                      }
                    })
                    .catch((e) => {
                      // 医生未绑定，继续绑定流程
                      // this.authorize();
                      this.previewContent();
                    });
                } else {
                  this.loading = false;
                  this.error = true;
                  this.msg = '内容格式错误';
                }
              })
              .catch((e) => {
                this.loading = false;
                this.error = true;
              });
          } else {
            this.loading = false;
            this.error = true;
            this.msg = '错误：无效的内容链接';
          }
        })
          .catch((e) => {
            if (e && e.response && e.response.status === 401) {
              // 401 未授权，做特定处理
              // this.authorize();
              this.previewContent();
            } else {
              // 其他错误
              this.loading = false;
              this.error = true;
              this.msg = '服务器发生错误';
            }
          });
      } else {
        if (this.$route.query.code) {
          // 获取到微信认证，获取open_id
          const code = this.$route.query.code;
          this.loading = true;
          getWeChatInfoByCode(code).then(res => {
            console.log(res);
            if (res.data && res.data.token) {
              setLocalStorage('token', res.data.token);
              setLocalStorage('seed', res.data.seed);
            }
            if (res.data && res.data.user && res.data.user.openid) {
              this.open_id = res.data.user.openid;
              setLocalStorage('open_id', this.open_id);
            }
            this.init(); // 重新执行init逻辑
          });
        } else {
          // 未获取微信认证，跳转认证获取open_id
          getWeChatConfig().then((res) => {
            let appid = res?.data?.appid;
            let redirect_uri = encodeURIComponent(
              window.location.origin +
                '/public/open' +
                (this.send_id ? '?send_id=' + this.send_id : ''),
            );
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=#wechat_redirect`;
          });
        }
      }
    },
    authorize() {
      getWeChatConfig().then((res) => {
        let appid = res?.data?.appid;
        let redirect_uri = encodeURIComponent(
          window.location.origin +
            '/public/authorize' +
            (this.send_id ? '?send_id=' + this.send_id : ''),
        );
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=#wechat_redirect`;
      });
    },
    canRenderSurveyBlock(block) {
      return this.canAnswerSurvey &&
        this.showContent &&
        this.content &&
        this.content.content_type !== '问卷' &&
        !this.showAuthPopup &&
        block &&
        block.type === 'survey' &&
        (block.questionnaireId || block.contentId);
    },
    buildHtmlContentBlocks(html) {
      if (!html) return [];

      const normalizedHtml = html.replace(
        /<div\b([^>]*\bdata-questionnaire(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+))?[^>]*)\/>/gi,
        '<div$1></div>',
      );
      const container = document.createElement('div');
      container.innerHTML = normalizedHtml;

      const placeholders = Array.from(container.querySelectorAll('[data-questionnaire]'));
      const surveyBlocks = [];

      placeholders.forEach((node, idx) => {
        const rawQuestionnaireId = (node.getAttribute('data-questionnaire') || '').trim();
        const questionnaireId = rawQuestionnaireId || this.contentQuestionnaireId;
        const marker = document.createComment(`questionnaire:${idx}`);

        surveyBlocks[idx] = {
          type: 'survey',
          key: `survey-${idx}-${questionnaireId || (this.content && this.content.content_id ? this.content.content_id : '')}`,
          questionnaireId,
          contentId: questionnaireId ? '' : (this.content && this.content.content_id ? String(this.content.content_id) : ''),
        };
        node.parentNode.replaceChild(marker, node);
      });

      const blocks = [];
      const markerReg = /<!--questionnaire:(\d+)-->/g;
      let lastIndex = 0;
      let match;
      let htmlIndex = 0;

      while ((match = markerReg.exec(container.innerHTML)) !== null) {
        const before = container.innerHTML.slice(lastIndex, match.index);
        if (before) {
          blocks.push({
            type: 'html',
            key: `html-${htmlIndex++}`,
            html: before,
          });
        }

        const surveyBlock = surveyBlocks[Number(match[1])];
        if (surveyBlock && (surveyBlock.questionnaireId || surveyBlock.contentId)) {
          blocks.push(surveyBlock);
        }
        lastIndex = markerReg.lastIndex;
      }

      const rest = container.innerHTML.slice(lastIndex);
      if (rest) {
        blocks.push({
          type: 'html',
          key: `html-${htmlIndex++}`,
          html: rest,
        });
      }

      if (!placeholders.length && this.contentQuestionnaireId) {
        blocks.push({
          type: 'survey',
          key: `survey-end-${this.contentQuestionnaireId}`,
          questionnaireId: this.contentQuestionnaireId,
          contentId: '',
        });
      }

      return blocks;
    },
    loadContentPreviewById(contentId) {
      this.loading = true;
      this.error = false;
      this.isContentPreview = true;
      this.canAnswerSurvey = true;
      this.showAuthPopup = false;

      getContentById(contentId)
        .then((res) => {
          const data = res && res.data !== undefined ? res.data : res;
          const content = Array.isArray(data && data.value)
            ? data.value[0]
            : (Array.isArray(data) ? data[0] : (data && data.data ? data.data : data));

          this.loading = false;

          if (!content || !content.content_id) {
            this.error = true;
            this.msg = '未找到内容';
            return;
          }

          this.showContent = true;
          this.content = content;

          if (this.content.content_name) {
            document.title = this.content.content_name;
          }

          if (this.content.content_body) {
            this.htmlContent = this.content.content_body;
            this.queueHtmlInteractionSetup();
          } else if (this.content.s3_file_name) {
            this.teardownHtmlInteractions();
            if (this.content.s3_file_name.indexOf('.pdf') > 0) {
              this.getS3FileUrl(this.content.s3_file_name);
            }
          } else if (this.content.content_url) {
            this.teardownHtmlInteractions();
            window.location.href = this.content.content_url;
          }
        })
        .catch(() => {
          this.loading = false;
          this.error = true;
          this.msg = '内容加载失败';
        });
    },
    loadContent() {
      this.loading = true;
      getContent(this.send_id).then((res) => {
        this.loading = false;
        this.showContent = true;
        this.canAnswerSurvey = true;
        this.content = res.data;

        // 设置窗口标题为内容的标题
        if (this.content.content_name) {
          document.title = this.content.content_name;
        }

        // 判断直接html body还是s3内容还是url
        if (this.content.content_type === '直播' && this.content.conference_id) {
          window.location.href = `/public/live?cid=${this.content.content_id}&send_id=${this.send_id}`;
        } else if (this.content.content_type === '问卷' && this.content.questionnaire_id) {
          window.location.href = `/public/survey?cid=${this.content.content_id}&send_id=${this.send_id}`;
        } else {
          // 记录打开日志
          let logOpenParams = {
            log_content_send_id: this.send_id,
            content_id: this.contentSend.content_id,
            reader_physician_id: this.openPhysician.physician_id,
            reader_openid: this.openPhysician.open_id,
            reader_unionid: this.openPhysician.union_id,
          };
          logContentOpen(logOpenParams).then((res) => {
            if (res && res.data) {
              this.logOpenId = res.data;
            }
          });

          if (this.content.content_body) {
            this.htmlContent = this.content.content_body;
            this.queueHtmlInteractionSetup();
          } else if (this.content.s3_file_name) {
            this.teardownHtmlInteractions();
            if (this.content.s3_file_name.indexOf('.pdf') > 0) {
              this.getS3FileUrl(this.content.s3_file_name);
              // this.isPdf = false;
            }
          } else if (this.content.content_url) {
            this.teardownHtmlInteractions();
            window.location.href = this.content.content_url;
            return;
          }

          if (this.intervalId) {
            clearInterval(this.intervalId);
          }
          this.intervalId = setInterval(() => {
            this.ticks++;
            if (this.ticks > (10 * 60) / 5) { // 10分钟后，每1分钟记录一次
              if (this.ticks % 12 !== 0) {
                return;
              }
            }
            logContentOpenDuration({log_content_open_id: this.logOpenId}).then();
          }, 5000);

          weixinOASDK.register({
            title: this.content.content_name,
            url: window.location.href,
            description: this.content.description,
            wx_logo: this.content.wx_logo,
          });
        }
      });
    },
    renderDirectContent(content) {
      this.loading = false;
      this.showContent = true;
      this.content = content;

      if (this.content.content_name) {
        document.title = this.content.content_name;
      }

      if (this.content.content_type === '直播' && this.content.conference_id) {
        window.location.href = `/public/live?cid=${this.content.content_id}`;
        return;
      }

      if (this.content.content_type === '问卷' && this.content.questionnaire_id) {
        window.location.href = `/public/survey?cid=${this.content.content_id}`;
        return;
      }

      if (this.content.content_body) {
        this.htmlContent = this.content.content_body;
        this.queueHtmlInteractionSetup();
      } else if (this.content.s3_file_name) {
        this.teardownHtmlInteractions();
        if (this.content.s3_file_name.indexOf('.pdf') > 0) {
          this.getS3FileUrl(this.content.s3_file_name);
        }
      } else if (this.content.content_url) {
        this.teardownHtmlInteractions();
        window.location.href = this.content.content_url;
        return;
      }

      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }

      weixinOASDK.register({
        title: this.content.content_name,
        url: window.location.href,
        description: this.content.description,
        wx_logo: this.content.wx_logo,
      });
    },
    previewContent() {
      this.showAuthPopup = true;
      this.loading = true;
      getContent(this.send_id).then((res) => {
        this.loading = false;
        this.showContent = true;
        this.canAnswerSurvey = false;
        this.content = res.data;

        // 设置窗口标题为内容的标题
        if (this.content.content_name) {
          document.title = this.content.content_name;
        }

        if (this.content.content_body) {
          this.htmlContent = this.content.content_body;
          this.queueHtmlInteractionSetup();
        } else {
          this.teardownHtmlInteractions();
        }

        weixinOASDK.register({
          title: this.content.content_name,
          url: window.location.href,
          description: this.content.description,
          wx_logo: this.content.wx_logo,
        });
      });
    },
    getS3FileUrl(key) {
      py.getS3ByKey(key).then((res) => {
        let currentMimeType = getMimeTypeBySuffix(
          key.split('.').pop().toLowerCase(),
        );
        let blob = new Blob([res.data], {
          type: currentMimeType,
        });
        this.s3Key = key;
        this.fileLocalLink = window.URL.createObjectURL(blob);
        console.log('this.fileLocalLink---->', this.fileLocalLink);
        this.loading = false;
        this.$store.dispatch('setDialogStatus', true);
        this.isPdf = false;
      });
    },
    closePdfFn() {
      this.$store.dispatch('setDialogStatus', false);
      this.fileLocalLink = null;
    },
    closeAuthPopup() {
      // this.showAuthPopup = false;
    },
    queueHtmlInteractionSetup() {
      this.$nextTick(() => {
        this.setupHtmlInteractions();
      });
    },
    setupHtmlInteractions() {
      const root = this.$refs.htmlContent;
      this.teardownHtmlInteractions();
      if (!root) {
        return;
      }

      this.initializeHtmlVisibility(root);
      this.htmlInteractionRoot = root;
      this.htmlContentClickHandler = (event) => {
        if (
          this.htmlSwipeSuppressClickUntil &&
          Date.now() < this.htmlSwipeSuppressClickUntil
        ) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        const swapImage = event.target.closest('img[data-swap-src]');
        if (swapImage && root.contains(swapImage)) {
          this.swapHtmlImage(swapImage);
          return;
        }

        const showTrigger = event.target.closest('[data-show-target]');
        if (showTrigger && root.contains(showTrigger)) {
          this.toggleHtmlTargets(root, showTrigger.dataset.showTarget);
        }
      };

      this.htmlSwipeTouchStartHandler = (event) => {
        const swipeImage = this.getHtmlSwipeImageFromEvent(event, root);
        const touch = event.touches && event.touches[0];
        if (!swipeImage || !touch) {
          return;
        }

        this.htmlSwipeTouch = {
          image: swipeImage,
          startX: touch.clientX,
          startY: touch.clientY,
          currentX: touch.clientX,
          currentY: touch.clientY,
        };
      };

      this.htmlSwipeTouchMoveHandler = (event) => {
        if (!this.htmlSwipeTouch) {
          return;
        }

        const touch = event.touches && event.touches[0];
        if (!touch) {
          return;
        }

        const deltaX = touch.clientX - this.htmlSwipeTouch.startX;
        const deltaY = touch.clientY - this.htmlSwipeTouch.startY;
        this.htmlSwipeTouch.currentX = touch.clientX;
        this.htmlSwipeTouch.currentY = touch.clientY;

        if (Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY)) {
          event.preventDefault();
        }
      };

      this.htmlSwipeTouchEndHandler = (event) => {
        this.handleHtmlSwipeEnd(event);
      };
      this.htmlSwipeTouchCancelHandler = () => {
        this.htmlSwipeTouch = null;
      };

      root.addEventListener('click', this.htmlContentClickHandler);
      root.addEventListener('touchstart', this.htmlSwipeTouchStartHandler);
      root.addEventListener('touchmove', this.htmlSwipeTouchMoveHandler, false);
      root.addEventListener('touchend', this.htmlSwipeTouchEndHandler);
      root.addEventListener('touchcancel', this.htmlSwipeTouchCancelHandler);
    },
    teardownHtmlInteractions() {
      if (this.htmlInteractionRoot && this.htmlContentClickHandler) {
        this.htmlInteractionRoot.removeEventListener(
          'click',
          this.htmlContentClickHandler,
        );
      }
      if (this.htmlInteractionRoot && this.htmlSwipeTouchStartHandler) {
        this.htmlInteractionRoot.removeEventListener(
          'touchstart',
          this.htmlSwipeTouchStartHandler,
        );
      }
      if (this.htmlInteractionRoot && this.htmlSwipeTouchMoveHandler) {
        this.htmlInteractionRoot.removeEventListener(
          'touchmove',
          this.htmlSwipeTouchMoveHandler,
          false,
        );
      }
      if (this.htmlInteractionRoot && this.htmlSwipeTouchEndHandler) {
        this.htmlInteractionRoot.removeEventListener(
          'touchend',
          this.htmlSwipeTouchEndHandler,
        );
      }
      if (this.htmlInteractionRoot && this.htmlSwipeTouchCancelHandler) {
        this.htmlInteractionRoot.removeEventListener(
          'touchcancel',
          this.htmlSwipeTouchCancelHandler,
        );
      }
      this.htmlInteractionRoot = null;
      this.htmlContentClickHandler = null;
      this.htmlSwipeTouchStartHandler = null;
      this.htmlSwipeTouchMoveHandler = null;
      this.htmlSwipeTouchEndHandler = null;
      this.htmlSwipeTouchCancelHandler = null;
      this.htmlSwipeTouch = null;
      this.htmlSwipeSuppressClickUntil = 0;
    },
    initializeHtmlVisibility(root) {
      root.querySelectorAll('[data-show-id]').forEach((element) => {
        const shouldHide = element.dataset.showHidden === 'true';
        this.setHtmlTargetVisibility(element, !shouldHide);
      });

      root
        .querySelectorAll('[data-show-target], img[data-swap-src], img[data-swipe-srcs]')
        .forEach((element) => {
          if (!element.style.cursor) {
            element.style.cursor = 'pointer';
          }
        });

      root.querySelectorAll('img[data-swipe-srcs]').forEach((imageElement) => {
        this.initializeHtmlSwipeImage(imageElement);
      });
    },
    toggleHtmlTargets(root, targetId) {
      if (!targetId) {
        return;
      }

      root.querySelectorAll('[data-show-id]').forEach((element) => {
        if (element.dataset.showId !== targetId) {
          return;
        }

        const isHidden = element.dataset.showHidden === 'true';
        this.setHtmlTargetVisibility(element, isHidden);
      });
    },
    setHtmlTargetVisibility(element, isVisible) {
      if (typeof element.dataset.showDisplay === 'undefined') {
        element.dataset.showDisplay = element.style.display || '';
      }

      element.dataset.showHidden = isVisible ? 'false' : 'true';
      element.style.display = isVisible ? element.dataset.showDisplay : 'none';
    },
    swapHtmlImage(imageElement) {
      const nextSrc = imageElement.dataset.swapSrc;
      if (!nextSrc) {
        return;
      }

      const currentSrc = imageElement.getAttribute('src') || '';
      imageElement.setAttribute('src', nextSrc);
      imageElement.dataset.swapSrc = currentSrc;
    },
    initializeHtmlSwipeImage(imageElement) {
      const swipeSrcs = this.getHtmlSwipeSrcs(imageElement);
      if (swipeSrcs.length <= 1) {
        return;
      }

      const currentSrc = (imageElement.getAttribute('src') || '').trim();
      const currentIndex = swipeSrcs.indexOf(currentSrc);
      const initialIndex = currentIndex >= 0 ? currentIndex : 0;

      imageElement.dataset.swipeIndex = String(initialIndex);
      imageElement.setAttribute('src', swipeSrcs[initialIndex]);
      imageElement.style.touchAction = 'pan-y';
    },
    getHtmlSwipeImageFromEvent(event, root) {
      if (!event || !event.target || !event.target.closest) {
        return null;
      }

      const swipeImage = event.target.closest('img[data-swipe-srcs]');
      if (!swipeImage || !root.contains(swipeImage)) {
        return null;
      }

      const swipeSrcs = this.getHtmlSwipeSrcs(swipeImage);
      return swipeSrcs.length > 1 ? swipeImage : null;
    },
    getHtmlSwipeSrcs(imageElement) {
      const currentSrc = (imageElement.getAttribute('src') || '').trim();
      const swipeSrcs = (imageElement.dataset.swipeSrcs || '')
        .split('|')
        .map((src) => src.trim())
        .filter(Boolean);

      if (currentSrc && swipeSrcs.indexOf(currentSrc) === -1) {
        swipeSrcs.unshift(currentSrc);
      }

      return swipeSrcs.filter((src, index) => swipeSrcs.indexOf(src) === index);
    },
    handleHtmlSwipeEnd(event) {
      if (!this.htmlSwipeTouch) {
        return;
      }

      const swipeTouch = this.htmlSwipeTouch;
      this.htmlSwipeTouch = null;

      const touch = event.changedTouches && event.changedTouches[0];
      if (!touch) {
        return;
      }

      const deltaX = touch.clientX - swipeTouch.startX;
      const deltaY = touch.clientY - swipeTouch.startY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);
      const minSwipeDistance = Math.max(
        35,
        Math.min(80, swipeTouch.image.clientWidth * 0.12),
      );

      if (absDeltaX < minSwipeDistance || absDeltaX <= absDeltaY * 1.2) {
        return;
      }

      this.htmlSwipeSuppressClickUntil = Date.now() + 400;
      this.swipeHtmlImage(swipeTouch.image, deltaX < 0 ? 1 : -1);
    },
    swipeHtmlImage(imageElement, direction) {
      const swipeSrcs = this.getHtmlSwipeSrcs(imageElement);
      if (swipeSrcs.length <= 1) {
        return;
      }

      const currentIndex = Number(imageElement.dataset.swipeIndex);
      const fallbackIndex = swipeSrcs.indexOf(
        (imageElement.getAttribute('src') || '').trim(),
      );
      const activeIndex = !isNaN(currentIndex) && currentIndex >= 0
        ? currentIndex
        : Math.max(fallbackIndex, 0);
      const nextIndex = Math.max(
        0,
        Math.min(swipeSrcs.length - 1, activeIndex + direction),
      );

      imageElement.dataset.swipeIndex = String(nextIndex);
      imageElement.setAttribute('src', swipeSrcs[nextIndex]);
    },

  },
};
</script>
<style lang="scss" scoped>
.logo {
  display: block;
  width: 60px;
  height: 60px;
  margin: 40px auto;
}
.spinner {
  display: block;
  width: 24px;
  height: 24px;
  margin: 60px auto 120px auto;
}
.bind-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  .banner {
    background-color: #aa341b;
    width: 100%;
    height: 280px;
    text-align: center;
  }
  img {
    width: 85px;
    height: 80px;
    margin-top: 80px;
  }

  .success-title {
    font-size: 18px;
    color: #fff;
    margin-top: 10px;
    margin-bottom: 40px;
  }

  .logo {
    width: 60px;
    height: 60px;
    margin: 40px 0;
  }

  .success-text {
    font-size: 16px;
    color: #333;
    line-height: 1.6;
    margin: 0px 0;
  }

  .close-btn {
    width: 40%;
    height: 44px;
    background: #ccc;
    color: #666;
    border: none;
    border-radius: 30px;
    font-size: 16px;
    margin-top: 40px;

    &:active {
      opacity: 0.9;
    }
  }
}
.html-content {
  padding: 0;
  max-width: 100%;
  overflow: auto;
  ::v-deep img {
    width: 100%;
    height: auto;
    display: block;
  }
}
.auth-popup {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 999;

  .popup-mask {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background-color: rgba(0, 0, 0, 0);
  }

  .popup-content.bottom {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 100%;
    background-color: #fff;
    // border-radius: 24rpx 24rpx 0 0;
    padding: 75px 20px 90px 20px;
    box-shadow: 0 -20px 20px rgba(255, 255, 255, 1);
    text-align: center;

    .popup-icon {
      width: 60px;
      height: 60px;
      background-color: #B73E23;
      border-radius: 50%;
      margin: 0 auto 15px;
      display: flex;
      align-items: center;
      justify-content: center;

      .download-icon {
        width: 30px;
        height: 30px;
      }
    }

    .popup-title {
      font-size: 18px;
      font-weight: 600;
      color: #333;
      margin-bottom: 30px;
    }

    .popup-desc {
      font-size: 13px;
      color: #666;
      line-height: 1.5;
      margin-bottom: 20px;
    }

    .popup-buttons {
      display: flex;
      gap: 10px;
      width: 60%;
      margin: 0 auto;

      .popup-btn {
        flex: 1;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 13px;
        border-radius: 6px;
        border: none;
        font-weight: 500;

        &.cancel-btn {
          background-color: #F9F9F9;
          color: #666;
        }

        &.confirm-btn {
          background-color: #B73E23;
          color: #fff;
        }
      }
    }
  }
}
</style>
